import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import '@fortawesome/fontawesome-free/css/all.min.css';


import Header from './resources/templates/fragments/Header';
import Footer from './resources/templates/fragments/Footer';
import Aside from './resources/templates/fragments/Aside';


import Inicio from './resources/templates/Inicio';
import Login from './resources/templates/Login';
import Productos from './resources/templates/Productos';
import Reseñas from './resources/templates/Reseñas';
import Aboutus from './resources/templates/Aboutus';


import DashboardProductos from './resources/templates/DashboardProductos';
import DashboardContactanos from './resources/templates/DashboardContactanos';
import DashboardReseñas from './resources/templates/DashboardResenas';


import DashboardUsuarios from './resources/templates/administration/DashboardUsuarios';
import DashboardClientes from './resources/templates/administration/DashboardClientes';
import DashboardClienteServicios from './resources/templates/administration/DashboardClienteServicios';


import ProtectedRoute from './components/ProtectedRoute';

function AppContent() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const location = useLocation();
  const isDashboard = location.pathname.toLowerCase().startsWith('/dashboard');

  return (
    <div className="App">
      {isDashboard && (
        <>
          <button className="menu-button-flotante" onClick={toggleMenu}>
            <i className={`fa-solid ${isMenuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
          </button>
          {isMenuOpen && <div className="sidebar-overlay" onClick={toggleMenu}></div>}
        </>
      )}

      <Routes>
        {/* --- RUTAS PÚBLICAS --- */}
        <Route path="/*" element={
          <>
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Inicio />} />
                <Route path="/login" element={<Login />} />
                <Route path="/productos" element={<Productos />} />
                <Route path="/reseñas" element={<Reseñas />} />
                <Route path="/aboutus" element={<Aboutus />} />
              </Routes>
            </main>
            <Footer />
          </>
        } />

        {/* --- RUTAS PRIVADAS (PROTEGIDAS) --- */}
        {/* Usamos un solo bloque para envolver todas las rutas de Dashboard */}

        <Route
          path="/DashboardContactanos"
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardContactanos /></main></div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/DashboardReseñas"
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardReseñas /></main></div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/DashboardProductos"
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardProductos /></main></div>
              </div>
            </ProtectedRoute>
          }
        />


        <Route
          path="/DashboardUsuarios"
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardUsuarios /></main></div>
              </div>
            </ProtectedRoute>
          }
        />


        <Route
          path="/DashboardClientes"
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardClientes /></main></div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/DashboardClienteServicios"
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardClienteServicios /></main></div>
              </div>
            </ProtectedRoute>
          }
        />


      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;